<template>
  <div class="descriptions">
    <div v-if="Boolean(title)" class="descriptions-title">{{ title }}</div>
    <div class="descriptions-view">
      <div class="descriptions-row">
        <slot v-if="$slots.default" />
        <div v-else style="text-align: center; color: grey;">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pbrElDescription',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  mounted () {
    this.syncLabelWidth()
    if (typeof ResizeObserver !== 'undefined') {
      this._resizeObserver = new ResizeObserver(() => this.syncLabelWidth())
      this._resizeObserver.observe(this.$el)
    }
  },
  updated () {
    this.syncLabelWidth()
  },
  beforeDestroy () {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect()
    }
  },
  methods: {
    syncLabelWidth () {
      this.$nextTick(() => {
        const row = this.$el.querySelector('.descriptions-row')
        if (!row) return
        const labels = row.querySelectorAll('.descriptions-item-label')
        if (!labels.length) return

        row.style.removeProperty('--descriptions-label-width')
        let maxWidth = 0
        labels.forEach((label) => {
          maxWidth = Math.max(maxWidth, label.offsetWidth)
        })
        if (maxWidth > 0) {
          row.style.setProperty('--descriptions-label-width', `${maxWidth}px`)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.descriptions {
  .descriptions-title {
    margin-bottom: 10px;
    color: rgba(0, 0, 0, .85);
    font-weight: 700;
    font-size: 16px;
    line-height: 1.5;
  }

  .descriptions-view {
    width: 100%;
    overflow: hidden;

    .descriptions-row {
      display: grid;
      grid-template-columns: repeat(24, minmax(0, 1fr));
      align-items: stretch;
      border: 1px solid #ebeef5;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }
  }
}
</style>

<style lang="scss">
@mixin descriptions-grid-span($prefix: null) {
  @for $i from 1 through 24 {
    @if $prefix {
      .descriptions-item.is-#{$prefix}-span-#{$i} {
        grid-column: span #{$i};
      }
    } @else {
      .descriptions-item.is-span-#{$i} {
        grid-column: span #{$i};
      }
    }
  }
}

@include descriptions-grid-span;

@media (max-width: 767px) {
  @include descriptions-grid-span(xs);
}

@media (min-width: 768px) {
  @include descriptions-grid-span(sm);
}

@media (min-width: 992px) {
  @include descriptions-grid-span(md);
}

@media (min-width: 1200px) {
  @include descriptions-grid-span(lg);
}

@media (min-width: 1920px) {
  @include descriptions-grid-span(xl);
}
</style>
